import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/MemberAuthContext';

// Chrání routu: vyžaduje přihlášení a volitelně konkrétní role.
export default function ProtectedRoute({ children, roles }) {
  const { member, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!member) return <Navigate to="/login" replace />;

  if (roles && roles.length && !roles.includes(member.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
